import React from 'react';
import { useContent } from '../i18n/LanguageContext';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';
import { HelpCircle } from 'lucide-react';

export default function Faq() {
  const c = useContent();
  const f = c.faq;
  return (
    <section id="faq" className="py-14 md:py-20 bg-white">
      <div className="lt-container grid lg:grid-cols-[0.9fr_1.1fr] gap-10 lg:gap-16 items-start">
        <div className="reveal lg:sticky lg:top-28">
          <span className="grid place-items-center w-12 h-12 rounded-xl bg-teal-50 text-teal-600">
            <HelpCircle className="w-6 h-6" />
          </span>
          <p className="mt-5 text-sm font-semibold uppercase tracking-widest text-teal-600">{f.eyebrow}</p>
          <h2 className="mt-3 font-display text-3xl md:text-4xl font-bold text-slate-900 leading-tight">{f.title}</h2>
          <p className="mt-4 text-lg text-slate-600">{f.subtitle}</p>
        </div>

        <div className="reveal">
          <Accordion type="single" collapsible defaultValue="item-0" className="space-y-3">
            {f.items.map((item, i) => (
              <AccordionItem key={i} value={`item-${i}`}
                className="rounded-2xl border border-slate-200 bg-white px-5 data-[state=open]:border-teal-300 data-[state=open]:bg-teal-50/40 transition-colors">
                <AccordionTrigger className="text-left font-display font-semibold text-slate-900 hover:no-underline py-5">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="text-slate-600 text-[15px] leading-relaxed pb-5">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
